// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610112339/js/" + chunkId + "." + {"44":"693ec162","225":"03ce4056","481":"bd113fd2","486":"b646112e","770":"65034b1e"}[chunkId] + ".0.3033462473091336.chunk.js";
};